import {
  Home,
  Phone,
  Settings,
  Users,
  MessageCircle,
  CreditCard,
  Search,
  User,
  Send,
} from "lucide-react";
import { NavLink } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import MobileHeader from "../components/MobileHeader";
import ProtectDashboardRoute from "../components/ProtectDashboardRoute";

export default function CommunityPage() {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <ProtectDashboardRoute />
      {/* Sidebar */}
      <Sidebar />
      <MobileHeader />

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}

        {/* Page Content */}
        <main className="flex-1 flex items-center justify-center p-8">
          <div className="bg-white rounded-2xl shadow p-12 text-center max-w-lg w-full">
            {/* Telegram Icon */}
            <div className="flex justify-center mb-6">
              <Send className="w-16 h-16 text-[#007AFF]" />
            </div>

            {/* Title */}
            <h1 className="text-3xl font-bold text-gray-800 mb-4">
              Join Our Telegram Community
            </h1>

            {/* Description */}
            <p className="text-gray-600 mb-8">
              Stay updated with the latest news, features, and promotions.
              Connect with other users, ask questions, and be the first to know
              about our updates.
            </p>

            {/* Join Button */}
            <a
              href="https://t.me/+29eYZNz_F6s2MGI8" // replace with real Telegram link
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#007AFF] text-white px-6 py-3 rounded-lg shadow hover:bg-[#005FCC] transition text-lg font-medium"
            >
              <Send className="w-5 h-5" />
              Join Our Telegram
            </a>
          </div>
        </main>
      </div>
    </div>
  );
}
